import { render, staticRenderFns } from "./crudInstancesSystemOthers.vue?vue&type=template&id=0b42b1e6&scoped=true&"
import script from "./crudInstancesSystemOthers.vue?vue&type=script&lang=js&"
export * from "./crudInstancesSystemOthers.vue?vue&type=script&lang=js&"
import style0 from "./crudInstancesSystemOthers.vue?vue&type=style&index=0&id=0b42b1e6&prod&lang=css&"
import style1 from "./crudInstancesSystemOthers.vue?vue&type=style&index=1&id=0b42b1e6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b42b1e6",
  null
  
)

export default component.exports